import { Box } from "@mui/material";
import LotSizeCalculator from "./components/LotSizeCalculator";
import TradeResultCalculator from "./components/TradeResultCalculator";

function App() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: "100vw",
        minHeight: "100vh",
        justifyContent: "center",
        gap: "200px",
        alignItems: "center",
        boxSizing: "border-box",
      }}
    >
      <LotSizeCalculator />
      <TradeResultCalculator />
    </Box>
  );
}

export default App;
